// COMMON CONFIG FOR PRINT BLEED AND CROP MARKS IN EDITOR AND EXPORT
// 0.125 in at 96 dpi - editor + export assumes 96 dpi
const PRINT_BLEED_PADDING = 12;

const CROP_MARK_LENGTH = 24;
const CROP_MARK_THICKNESS = 1;
const CROP_MARK_LENGTH_CSS = `calc(100% - ${PRINT_BLEED_PADDING}px)`;
const CROP_MARK_BORDER_CSS = `${CROP_MARK_THICKNESS}px solid black`;

const CROP_MARK_WRAPPER_PROPS = {
  position: 'absolute' as 'absolute',
  width: `${CROP_MARK_LENGTH + PRINT_BLEED_PADDING}px`,
  height: `${CROP_MARK_LENGTH + PRINT_BLEED_PADDING}px`,
};

const COMMON_DECORATOR_PROPS = {
  content: '""',
  position: 'absolute' as const,
};

const CROP_MARK_CONFIG = [
  {
    // top left
    top: `-${CROP_MARK_LENGTH}px`,
    left: `-${CROP_MARK_LENGTH}px`,
    _before: {
      ...COMMON_DECORATOR_PROPS,
      top: 0,
      right: 0,
      height: CROP_MARK_LENGTH_CSS,
      borderRight: CROP_MARK_BORDER_CSS,
    },
    _after: {
      ...COMMON_DECORATOR_PROPS,
      bottom: 0,
      left: 0,
      width: CROP_MARK_LENGTH_CSS,
      borderBottom: CROP_MARK_BORDER_CSS,
    },
  },
  {
    // top right
    top: `-${CROP_MARK_LENGTH}px`,
    right: `-${CROP_MARK_LENGTH}px`,
    _before: {
      ...COMMON_DECORATOR_PROPS,
      top: 0,
      left: 0,
      height: CROP_MARK_LENGTH_CSS,
      borderLeft: CROP_MARK_BORDER_CSS,
    },
    _after: {
      ...COMMON_DECORATOR_PROPS,
      bottom: 0,
      right: 0,
      width: CROP_MARK_LENGTH_CSS,
      borderBottom: CROP_MARK_BORDER_CSS,
    },
  },
  {
    // bottom left
    bottom: `-${CROP_MARK_LENGTH}px`,
    left: `-${CROP_MARK_LENGTH}px`,
    _before: {
      ...COMMON_DECORATOR_PROPS,
      bottom: 0,
      right: 0,
      height: CROP_MARK_LENGTH_CSS,
      borderRight: CROP_MARK_BORDER_CSS,
    },
    _after: {
      ...COMMON_DECORATOR_PROPS,
      top: 0,
      left: 0,
      width: CROP_MARK_LENGTH_CSS,
      borderTop: CROP_MARK_BORDER_CSS,
    },
  },
  {
    // bottom right
    bottom: `-${CROP_MARK_LENGTH}px`,
    right: `-${CROP_MARK_LENGTH}px`,
    _before: {
      ...COMMON_DECORATOR_PROPS,
      bottom: 0,
      left: 0,
      height: CROP_MARK_LENGTH_CSS,
      borderLeft: CROP_MARK_BORDER_CSS,
    },
    _after: {
      ...COMMON_DECORATOR_PROPS,
      top: 0,
      right: 0,
      width: CROP_MARK_LENGTH_CSS,
      borderTop: CROP_MARK_BORDER_CSS,
    },
  },
];

export { PRINT_BLEED_PADDING, CROP_MARK_WRAPPER_PROPS, CROP_MARK_CONFIG };
